import { useDispatch } from "react-redux";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import {
  setEnabledQueryMultipleClientReport,
  setReportsMultipleClientReport,
  setTotalCountMultipleClientReport,
  useSelectEnabledMultipleClientReport,
  useSelectFiltersMultipleClientReport,
  useSelectPageMultipleClientReport,
  useSelectSizeMultipleClientReport,
  useSelectTotalCountMultipleClientReport,
} from "../../../../redux/features/reports/multipleClientReportSlice";
import { generate } from "../../../../services/report";
import { useQuery } from "@tanstack/react-query";
import { formatFiltersReports } from "../../singleReport/utils";

const useMultipleClientReportFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelectFiltersMultipleClientReport();
  const exportPermission = useCheckPermission("DOWNLOAD_REPORT");

  const page = useSelectPageMultipleClientReport();
  const size = useSelectSizeMultipleClientReport();
  const totalCount = useSelectTotalCountMultipleClientReport();
  const enabled = useSelectEnabledMultipleClientReport();

  const setEnabled = (val) =>
    dispatch(setEnabledQueryMultipleClientReport(val));

  const { isLoading, refetch } = useQuery({
    queryKey: [
      "get-multiple-client-report",
      page,
      size,
      formatFiltersReports(filters),
    ],
    queryFn: () => generate(page, size, formatFiltersReports(filters)),
    refetchOnWindowFocus: false,
    enabled: enabled,
    select: (data) => {
      const { elements, data: reports } = data;
      dispatch(setTotalCountMultipleClientReport(elements));
      dispatch(setReportsMultipleClientReport(reports));
    },
  });

  return {
    page,
    size,
    totalCount,
    exportPermission,
    isLoading,
    enabled,
    getReports: refetch,
    setEnabled,
  };
};

export default useMultipleClientReportFilters;
